import React, { useCallback, useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox, InputNumber } from 'antd';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { fetchItemsByOrganization } from '@resources/Item/actions';
import { formErrorHandler } from '@common/utils/form';

const FormItem = Form.Item;

const SupplierForm = (props) => {
	const {
		module,
		data,
		onSubmit,
		fetchItemsByOrganization,
		match,
		onCancel,
		organization,
	} = props;
	const intl = useIntl();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleFinish = useCallback(
		(values) => {
			setLoading(true);

			if (organization?._id) {
				values['organization'] = organization?._id;
			}

			if (module) {
				values['module'] = module._id;
				values[module.code] = match?.params[`moduleId`];
			}

			onSubmit(values)
				.then(() => setLoading(false))
				.catch((err) => {
					setLoading(false);
					formErrorHandler(err, values, form);
				});
		},
		[onSubmit, organization]
	);

	useEffect(() => {
		const fetchData = async () => {
			await fetchItemsByOrganization(organization?._id);
		};
		fetchData();
	}, [organization]);

	return (
		<Form
			form={form}
			name="supplier-form"
			layout="vertical"
			onFinish={handleFinish}
			initialValues={{ ...data, item: data?.item?._id }}>
			<FormItem
				label={intl.formatMessage({
					id: 'common.name',
					defaultMessage: 'Name',
				})}
				name="name"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.name.required',
							defaultMessage: 'Please input name',
						}),
					},
				]}>
				<Input
					placeholder={intl.formatMessage({
						id: 'common.name',
						defaultMessage: 'Name',
					})}
				/>
			</FormItem>

			<FormItem
				label={intl.formatMessage({
					id: 'common.description',
					defaultMessage: 'Description',
				})}
				name="description"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.description.required',
							defaultMessage: 'Please input description',
						}),
					},
				]}>
				<Input.TextArea
					rows={4}
					placeholder={intl.formatMessage({
						id: 'common.description',
						defaultMessage: 'Description',
					})}
				/>
			</FormItem>

			<FormItem
				label={intl.formatMessage({
					id: 'common.location',
					defaultMessage: 'Location',
				})}
				name="location"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.location.required',
							defaultMessage: 'Please input location',
						}),
					},
				]}>
				<Input
					placeholder={intl.formatMessage({
						id: 'common.location',
						defaultMessage: 'Location',
					})}
				/>
			</FormItem>

			<Form.List name="price">
				{() => (
					<>
						<FormItem
							label={intl.formatMessage({
								id: 'common.buy',
								defaultMessage: 'Buy',
							})}
							name="buy"
							rules={[
								{
									required: true,
									message: intl.formatMessage({
										id: 'form.validation.buy.required',
										defaultMessage: 'Please input buy',
									}),
								},
							]}>
							<InputNumber
								placeholder={intl.formatMessage({
									id: 'common.buy',
									defaultMessage: 'Buy',
								})}
							/>
						</FormItem>

						<FormItem
							label={intl.formatMessage({
								id: 'common.sell',
								defaultMessage: 'Sell',
							})}
							name="sell"
							rules={[
								{
									required: true,
									message: intl.formatMessage({
										id: 'form.validation.sell.required',
										defaultMessage: 'Please input sell',
									}),
								},
							]}>
							<InputNumber
								placeholder={intl.formatMessage({
									id: 'common.sell',
									defaultMessage: 'Sell',
								})}
							/>
						</FormItem>
					</>
				)}
			</Form.List>

			<FormItem name="isActive" valuePropName="checked">
				<Checkbox>
					{intl.formatMessage({
						id: 'common.isActive',
						defaultMessage: 'Is Active',
					})}
				</Checkbox>
			</FormItem>
			<FormItem className="mt-5">
				<Button type="secondary" onClick={() => onCancel()}>
					{intl.formatMessage({
						id: 'common.cancel',
						defaultMessage: 'Cancel',
					})}
				</Button>
				&nbsp;&nbsp;
				<Button
					loading={loading}
					type="primary"
					htmlType="submit"
					className="login-form-button">
					{intl.formatMessage({
						id: 'common.submit',
						defaultMessage: 'Submit',
					})}
				</Button>
			</FormItem>
		</Form>
	);
};

const mapStateToProps = ({ auth, items, organization }) => {
	return {
		auth,
		items,
		organization,
	};
};

export default connect(mapStateToProps, { fetchItemsByOrganization })(
	SupplierForm
);
